/**
 * Date formatting utilities for PTC Builder
 */

/**
 * Format a date string or Date object to MM/DD/YYYY format
 * @param {string|Date} dateInput - Date string (YYYY-MM-DD or ISO format) or Date object
 * @returns {string} Formatted date string in MM/DD/YYYY format
 */
export const formatDateDisplay = (dateInput) => {
  if (!dateInput) return '-';
  
  try {
    let date;
    
    if (typeof dateInput === 'string') {
      // Handle YYYY-MM-DD format
      if (/^\d{4}-\d{2}-\d{2}$/.test(dateInput)) {
        const [year, month, day] = dateInput.split('-');
        return `${month}/${day}/${year}`;
      }
      // Handle ISO date string
      date = new Date(dateInput);
    } else if (dateInput instanceof Date) {
      date = dateInput;
    } else {
      return '-';
    }
    
    if (isNaN(date.getTime())) return '-';
    
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    
    return `${month}/${day}/${year}`;
  } catch (e) {
    return '-';
  }
};

/**
 * Format a date string or Date object to MM/DD/YYYY HH:MM AM/PM format
 * @param {string|Date} dateInput - Date string or Date object
 * @returns {string} Formatted datetime string
 */
export const formatDateTimeDisplay = (dateInput) => {
  if (!dateInput) return '-';
  
  try {
    const date = new Date(dateInput);
    if (isNaN(date.getTime())) return '-';
    
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    
    return `${month}/${day}/${year} ${hours}:${minutes} ${ampm}`;
  } catch (e) {
    return '-';
  }
};
